import { BuyToneDto } from '../../../../core/dto/buytone/buytonedto';
import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BuyToneResponse } from '../../../../core/api/tune/buytune/buytoneresponse';
import { BuyToneRequestImpl } from '../../../../core/api/tune/buytune/buytonerequest';
import { BaseContext } from '../../../../utils/basecontext';
import { ToneProcessorFactory } from '../../../../core/processorfactory/toneprocessorfactory';
import { AddNameTuneRequestImpl } from 'src/com/sixdee/crbtportal/core/api/nametune/addnametunerequest';
import { AddNameTuneResponse } from 'src/com/sixdee/crbtportal/core/api/nametune/addnametuneresponse';
import { AddNameTuneDto } from 'src/com/sixdee/crbtportal/core/dto/addnametune/addnametunedto';
import { UpgradePackDto } from 'src/com/sixdee/crbtportal/core/dto/upgradepack/upgradepackdto';
import { UpgradePackResponse } from 'src/com/sixdee/crbtportal/core/api/tune/upgradepack/upgradepackresponse';
import { UpgradePackRequestImpl } from 'src/com/sixdee/crbtportal/core/api/tune/upgradepack/upgradepackrequest';

export interface UpgradePackAPIModel extends APIModel 
{
    buyTone(buyToneDto: BuyToneDto): void;
    loggedInBuyTone(buyToneDto: BuyToneDto): void;
    buyNameTone(buyToneDto: AddNameTuneDto): void ;
    upgradePack(upgradePack: UpgradePackDto): void;
    upgradePackNonLoggedIn(upgradePack: UpgradePackDto): void;
}

export class UpgradePackAPIModelImpl extends APIModelImpl implements UpgradePackAPIModel 
{
    private toneProcessor: ToneProcessorFactory;
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) 
    {
        super(applicationContext, apiModelHandler);
        this.toneProcessor = this.getAPIProcesssorFactory().getToneProcessorFactory();
    }

  upgradePack(upgradePack: UpgradePackDto): void {
    this.toneProcessor.getUpgradePackAPIProcessor()
        .success((buyResponse : UpgradePackResponse)=>
         {
           console.log("----success"+buyResponse.getDescription());
            this.getAPIModelHandler().onSuccess(buyResponse.getAPIFeature(), 
            buyResponse.getDescription(), buyResponse);
         })
       .failure((buyResponse : UpgradePackResponse)=>
       {
        console.log("----failure"+buyResponse.getDescription());
           this.getAPIModelHandler().onFailure(buyResponse.getAPIFeature(), 
           buyResponse.getDescription(), buyResponse);
         })
       .execute(new UpgradePackRequestImpl(upgradePack));
  }

  upgradePackNonLoggedIn(upgradePack: UpgradePackDto): void {
    this.toneProcessor.getUpgradePackNonLoggedInAPIProcessor()
        .success((buyResponse : UpgradePackResponse)=>
         {
           console.log("----success"+buyResponse.getDescription());
            this.getAPIModelHandler().onSuccess(buyResponse.getAPIFeature(), 
            buyResponse.getDescription(), buyResponse);
         })
       .failure((buyResponse : UpgradePackResponse)=>
       {
        console.log("----failure"+buyResponse.getDescription());
           this.getAPIModelHandler().onFailure(buyResponse.getAPIFeature(), 
           buyResponse.getDescription(), buyResponse);
         })
       .execute(new UpgradePackRequestImpl(upgradePack));
  }

    loggedInBuyTone(buyToneDto: BuyToneDto): void 
    {
        this.toneProcessor.getBuyToneAPIProcessor()
        .success((buyResponse : BuyToneResponse)=>
         {
           console.log("----success"+buyResponse.getDescription());
            this.getAPIModelHandler().onSuccess(buyResponse.getAPIFeature(), 
            buyResponse.getDescription(), buyResponse);
         })
       .failure((buyResponse : BuyToneResponse)=>
       {
        console.log("----failure"+buyResponse.getDescription());
           this.getAPIModelHandler().onFailure(buyResponse.getAPIFeature(), 
           buyResponse.getDescription(), buyResponse);
         })
       .execute(new BuyToneRequestImpl(buyToneDto));
    }
    buyTone(buyToneDto: BuyToneDto): void 
    {
        this.toneProcessor.getBuyToneNonLoggedUserAPIProcessor()
        .success((buyResponse : BuyToneResponse)=>
         {
            this.getAPIModelHandler().onSuccess(buyResponse.getAPIFeature(), 
            buyResponse.getDescription(), buyResponse);
         })
       .failure((buyResponse : BuyToneResponse)=>
       {
           this.getAPIModelHandler().onFailure(buyResponse.getAPIFeature(), 
           buyResponse.getDescription(), buyResponse);
         })
       .execute(new BuyToneRequestImpl(buyToneDto));
    }

    buyNameTone(buyToneDto: AddNameTuneDto): void 
    {
      this.getAPIProcesssorFactory().getNameTuneProcessorFactory()
                   .getAddNameTuneNonLoggedInAPIProcessor()
                .success((addNameTuneResponse: AddNameTuneResponse)=>
                {
                  console.log("NAMETUNE SUCCESS ######################################################3");
                   this.getAPIModelHandler().onSuccess(addNameTuneResponse.getAPIFeature(), 
                   addNameTuneResponse.getDescription(), addNameTuneResponse);
                })
                .failure((addNameTuneResponse: AddNameTuneResponse)=>
                {
                    this.getAPIModelHandler().onFailure(addNameTuneResponse.getAPIFeature(), 
                    addNameTuneResponse.getDescription(), undefined);
                })
                .execute(new AddNameTuneRequestImpl(buyToneDto));
    }
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/upgrade_pack/upgradeapimodel.tsx